<template>
  <div>
    <div v-if="isLoading">
      <OtherLoading />
    </div>
    <div v-else>
      <div class="d-flex justify-content-between align-items-center">
        <InputText
          v-model="filter.search"
          type="text"
          faIcon="search"
          className="my-3 bg-second w-50"
          placeholder="ค้นหา Serial"
          @onClickIcon="handleSearch"
          @onEnter="handleSearch"
        />
      </div>
      <b-table
        responsive
        striped
        hover
        :fields="fields"
        :items="items"
        :busy="isBusy"
        show-empty
        empty-text="No matching records found"
        class="table-main"
      >
        <template v-slot:cell(name)="{ item }">
          <div
            class="text-link"
            @click="$router.push(`/product/detail/${item.product_id}`)"
          >
            {{ item.name }}
          </div>
          <span class="text-gray">{{ item.barcode }}</span>
        </template>
        <template v-slot:cell(price)="{ item }">
          {{ item.price | numeral("0,0.00") }}
        </template>
        <template v-slot:cell(invoice_no)="{ item }">
          <a
            class="ml-2 text-link"
            :href="`/transaction/detail/${
              item.transaction_id
            }/${item.user_guid}/0`"
            >{{ item.invoice_no || '-' }}</a
          >
        </template>
        <template v-slot:cell(user_transaction_status_name)="{ item }">
          <div
            :class="{
              'text-success': item.user_transaction_status_id == 1,
              'text-danger': item.user_transaction_status_id == 2,
            }"
          >
            {{ item.user_transaction_status_name }}
          </div>
        </template>
        <template v-slot:table-busy>
          <div class="text-center text-black my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="ml-2">Loading...</strong>
          </div>
        </template>
      </b-table>
      <Pagination
        @handleChangeTake="handleChangeTake"
        :pageOptions="pageOptions"
        :filter="filter"
        :rows="rows"
        @pagination="pagination"
      />
    </div>
  </div>
</template>
<script>
import OtherLoading from "@/components/loading/OtherLoading";
import HeaderPanel from "@/components/HeaderPanel.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    OtherLoading,
    HeaderPanel,
  },
  props: {
    branchList: {
      required: false,
    },
  },
  computed: {
    ...mapGetters({
      branchId: "getBranchId",
    }),
  },
  name: "Product",

  data() {
    return {
      isLoading: false,
      filter: {
        search: "",
        page: 1,
        take: 10,
        branch_id: "",

        product_id: this.$route.params.id,
      },
      id: this.$route.params.id,
      items: [],
      isBusy: false,
      rows: 0,
      pageOptions: [
        { value: 5, text: "5 / page" },
        { value: 10, text: "10 / page" },
        { value: 30, text: "30 / page" },
        { value: 50, text: "50 / page" },
        { value: 100, text: "100 / page" },
      ],
      fields: [
        {
          key: "serial",
          label: "Serial",
          thClass: "w-1",
        },
        {
          key: "branch_name",
          label: "Branch Name",

          thClass: "w-1",
        },
        {
          key: "price",
          label: "ราคา ",
          thClass: "w-1",
        },
        {
          key: "invoice_no",
          label: "Invoice No.",

          thClass: "w-1",
        },
        {
          key: "user_transaction_status_name",
          label: "Transaction Status",

          thClass: "w-1",
        },
      ],

      stockList: [],
    };
  },
  async created() {
    await this.getList();
  },
  methods: {
    async getList() {
      this.isBusy = true;
      this.filter.branch_id = this.branchId;
      const res = await this.axios.post(
        `${this.$baseUrl}/product/get_product_serial_history/${this.id}`,
        this.filter
      );
      if (res.result == 1) {
        this.isLoading = false;
        this.items = res.detail.data;
        this.rows = res.detail.count;
      }
      this.isLoading = false;
      this.isBusy = false;
    },
    async handleSearch() {
      this.filter.page = 1;
      await this.getList();
    },
    pagination(page) {
      this.filter.page = page;

      this.getList();
    },
    handleChangeTake(value) {
      this.filter.page = 1;
      this.filter.take = value;

      this.getList();
    },

    clearFilter() {
      this.filter = {
        search: "",
        page: 1,
        take: 10,
        branch_id: "",
        sortBy: "",
        sortDesc: false,
        SortType: true,
        SortColumnId: 0,
        product_id: this.$route.params.id,
        filter_stock_type_id: 0,
        filter_branch_id: 0,
      };
      this.getList();
    },
  },
};
</script>
